// Shared option sets for the onboarding questionnaire.
export const AGE_RANGES = ["<16", "16-24", "25-35", "36-55", ">55"];

export const SEX_OPTIONS = [
  { value: "M", label: "Male" },
  { value: "F", label: "Female" },
];

export const EDUCATION_LEVELS = [
  "No formal qualification",
  "Secondary / high school",
  "Vocational / trade certificate",
  "Bachelor's degree",
  "Master's degree",
  "Doctorate (PhD)",
  "Other",
];
